<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="field mt1">
        <div class="date-picker control has-icons-right">
          <div v-if="isIOS()">
            <input v-model="date" type="date" class="datetime-input" />
          </div>
          <datetime
            v-model="date"
            v-if="!isIOS()"
            :auto="true"
            :autoDate="false"
            zone="UTC"
            valueZone="UTC"
            :format="config.format"
          ></datetime>
          <span class="icon is-right"><i class="icon icon-calendar"></i></span>
        </div>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import { isIOS } from "mobile-device-detect";
import { DateTime } from "luxon";
import baseQuestion from "./baseQuestion";

export default {
  name: "date",

  mixins: [baseQuestion],

  data() {
    return {
      date: null,
      config: {
        format: DateTime.DATE_FULL
      }
    };
  },

  watch: {
    date(newDate, oldDate) {
      let parsedNewDate = DateTime.fromISO(newDate);
      if (parsedNewDate.isValid) {
        this.choice = this.date;
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  },

  methods: {
    isIOS() {
      return isIOS;
    }
  },

  mounted() {
    if (this.choice) {
      this.date = this.choice;
    }
  }
};
</script>

<style lang="scss">
.date-range-picker {
  h3,
  legend {
    display: none;
  }
}
</style>
